import { $, $$ } from '@starberry/components';
import { Routes } from '../../routes';
import { Icon } from "@chakra-ui/react";

export default {
  $: 'Dashboard',
  title: '',
  content: [
    {
      $: 'Box',
      props: {
        px: $('theme.space.12'),
        h: '100%',
        d: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      },
      children: [
        {
          $: 'Box',
          props: {
            d: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          },
          children: [
            {
              component: Icon,
              as: $('constants.icons.errorPage'),
              fontSize: 80,
              opacity: 0.2,
            },
            {
              $: 'H5',
              props: {
                as: 'h3',
                mt: 2,
                fontSize: $$(
                  ('constants.headings.headingSize.h5'),
                  null,
                  ('constants.headings.headingSize.h3'),
                ),
              },
              children: $(
                'constants.translations.notFoundPage.ERROR_404_TITLE',
                'The page you’re after seems to be missing.'
              ),
            },
            {
              $: 'Text',
              props: {
                mt: 2,
                mb: 4,
                fontSize: $$(
                  ('constants.body.bodySize.small'),
                  null,
                  ('constants.body.bodySize.medium'),
                ),
              },
              children: $(
                'constants.translations.noContent.ERROR_404_SUB_TITLE',
                'This is maybe because it has been removed, we’ve changed it’s name or it is temporarily unavailable.'
              ),
            },
            {
              $: 'WrappedLink',
              props: {
                to: Routes.DashboardPage,
                color: $('constants.colors.primary'),
              },
              children: $('constants.translations.noContent.ERROR_BTN_LABEL', 'Go To Dashboard'),
            },
          ],
        },
      ],
    },
  ],
};
